import React, { useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import './AccountPage.css'; // Import your custom CSS file



const AccountPage = () => {
  const navigate = useNavigate();



  const logoutStyle = {
    margin: '5px',
    padding: '6px 12px',
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer'
  };

  return (
    <div style={{ backgroundColor: '#45BFC8', padding: '10px' }}>
    <div className="header-account-page" style={{ backgroundColor: '#45BFC8', padding: '10px' }}> 
    <div className="column-one-account">
    <div className="profile-container">

    {/*<Icon icon="material-symbols:tv-signin-outline" color="black" width="30" height="30" style={{ marginRight: '10px' }} />*/}
   
</div>



    </div>

    <div className="column-two-account">
   
    </div>
  
    <div className="column-three-account" style={{ backgroundColor: '#45BFC8', padding: '10px' }}>
  <div style={{ backgroundColor: '#389FA6', borderRadius: '8px', padding: '10px', display: 'inline-block' }}>
    <h2 style={{ margin: '0', color: '#ffffff' }}>SP COMMUNITY</h2> 
  </div>
</div>


    </div>
    <div className="card-container">
    
    <button onClick={() => navigate('/workers')} className="card-button">
            <div className="card">
              <h3>Workers</h3>
              <Icon icon="healthicons:miner-worker" color="#000000" width="120" height="120" />
            </div>
          </button>
          <button onClick={() => navigate('/jobs')} className="card-button">
            <div className="card">
              <h3>Jobs</h3>
              <Icon icon="emojione:briefcase" color="#000000" width="120" height="120" />
            </div>
          </button>
          <button onClick={() => navigate('/events')} className="card-button">
            <div className="card">
              <h3>Events</h3>
              <Icon icon="emojione-monotone:spiral-notepad" color="#000000" width="120" height="120" />
            </div>
          </button>
          <button onClick={() => navigate('/newsletter')} className="card-button">
            <div className="card">
              <h3>Newsletter</h3>
              <Icon icon="ri:mail-volume-fill" color="#000000" width="120" height="120" />
            </div>
          </button>
        
  </div>

    
  </div>

  );
}

export default AccountPage;
